<template>
  <div>
    <div class="contai">
      <!-- <div class="text" v-for="(item,index) in list" :key="index">
            <div class="title" @click="noticedetail(item)"> {{item.title}}</div>
        </div> -->
        <router-link to="/newPeple" class="helpbox">新手上路 <van-icon name="arrow" /></router-link>
        <router-link to="/disturb" class="helpbox">配送服务 <van-icon name="arrow" /></router-link>
        <router-link to="/service" class="helpbox">售后服务 <van-icon name="arrow" /></router-link>
        <router-link to="/haibei" class="helpbox">海贝计划 <van-icon name="arrow" /></router-link>

    </div>
    <!-- <div class="paging">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" @current-change="changePage"></el-pagination>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      activeNames: "",
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.text {
  padding-top: 50px;
}
/deep/.blue {
  color: #2283e2 !important;
}
.contai {
  background: #fff;
  // border: 1px solid #2283e2;
  padding: 20px;
}
.helpbox{
  // border-bottom: 1px solid #ddd;
  padding: 20px 10px;
  color: #2283e2;
  font-size: 1.2em;
  display: block;
}
.van-icon{
  float: right;
  color: #999;
  vertical-align: middle;
  margin-top: 2px;
}

</style>
